import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../../utils/helpers/model.helper';
import { DepositToggleValue } from './deposit-toggle-value.model';

export const DEPOSIT_TOGGLE_SCHEMA = Object.freeze({
  INVOICE: DepositToggleValue,
  ESTIMATE: DepositToggleValue,
});
const RECORD = generateSchema(DEPOSIT_TOGGLE_SCHEMA);
const KEYS: any = generateKeys(DEPOSIT_TOGGLE_SCHEMA);

export class DepositToggle extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));

    return setInModel(this, [
      {
        key: KEYS.INVOICE,
        value: this.get(KEYS.INVOICE)
          ? new DepositToggleValue(this.invoice)
          : null,
      },
      {
        key: KEYS.ESTIMATE,
        value: this.get(KEYS.ESTIMATE)
          ? new DepositToggleValue(this.estimate)
          : null,
      },
    ]) as DepositToggle;
  }

  get invoice(): DepositToggleValue {
    return this.get(KEYS.INVOICE);
  }

  get estimate(): DepositToggleValue {
    return this.get(KEYS.ESTIMATE);
  }
}
